/* eslint-disable camelcase */
/* eslint-disable max-lines */
/* eslint-disable max-lines-per-function */
import React from "react";
import { SelectInputProps } from "@material-ui/core/Select/SelectInput";
import { Typography } from "@material-ui/core";
import { RadioBasic, RadioYesNo, RadioYesNoSmall } from "components/common/form";
import { InputDatePicker } from "components/common/form/input/input-date-picker";
import AddressGroup from "components/common/form/address-group";
import { Column, FormRow } from "components/common/html";
import { unitSizeMetadata } from "model/interest/unit-size";

import {
  isFieldInSchema,
  getLabelFromSchema,
  gatherAllHouseholdMembers,
  ShouldRenderField,
  // thin wrapper components to clean up duplication
  Input,
  Checkbox as NormalCheckbox,
  Select,
  getUnitSizeOptions,
} from "pages/dashboard/interests-form/interest-form-utils";
import { languages } from "../utils";

const styles = {
  sectionBtn: {
    marginRight: 10,
  },
} as const;


const Checkbox = (props: any) => <NormalCheckbox size="small" {...props} />;

const InterestForm:React.FC<{formData: any, handleChangeHousehold?: SelectInputProps["onChange"], validationSchema: any[]}> =
(props) => {
  // keep track of what fields are showing after pressing 'add asset'
  const [state, setState] = React.useState<any>({
    household_member_0_net_self_income_inc: 0,
    household_member_1_net_self_income_inc: 0,
    household_member_2_net_self_income_inc: 0,
    household_member_3_net_self_income_inc: 0,
    household_member_4_net_self_income_inc: 0,
    household_member_5_net_self_income_inc: 0,
    household_member_0_income_notlist_inc: 0,
    household_member_1_income_notlist_inc: 0,
    household_member_2_income_notlist_inc: 0,
    household_member_3_income_notlist_inc: 0,
    household_member_4_income_notlist_inc: 0,
    household_member_5_income_notlist_inc: 0,
    household_member_0_employer_inc: 0,
    household_member_1_employer_inc: 0,
    household_member_2_employer_inc: 0,
    household_member_3_employer_inc: 0,
    household_member_4_employer_inc: 0,
    household_member_5_employer_inc: 0,
    // assets
    household_member_0_checking_inc: 0,
    household_member_1_checking_inc: 0,
    household_member_2_checking_inc: 0,
    household_member_3_checking_inc: 0,
    household_member_4_checking_inc: 0,
    household_member_5_checking_inc: 0,
    household_member_0_savings_inc: 0,
    household_member_1_savings_inc: 0,
    household_member_2_savings_inc: 0,
    household_member_3_savings_inc: 0,
    household_member_4_savings_inc: 0,
    household_member_5_savings_inc: 0,
    household_member_0_asset_notlist_inc: 0,
    household_member_1_asset_notlist_inc: 0,
    household_member_2_asset_notlist_inc: 0,
    household_member_3_asset_notlist_inc: 0,
    household_member_4_asset_notlist_inc: 0,
    household_member_5_asset_notlist_inc: 0,
    mailingAddressType: props.formData.mailing_address_type,
    household_member_0_citizen_id_type: props.formData.household_member_0_citizen_id_type,
    household_member_1_citizen_id_type: props.formData.household_member_1_citizen_id_type,
    household_member_2_citizen_id_type: props.formData.household_member_2_citizen_id_type,
    household_member_3_citizen_id_type: props.formData.household_member_3_citizen_id_type,
    household_member_4_citizen_id_type: props.formData.household_member_4_citizen_id_type,
    household_member_5_citizen_id_type: props.formData.household_member_5_citizen_id_type,
    household_member_0_gender: props.formData.household_member_0_gender,
    household_member_1_gender: props.formData.household_member_1_gender,
    household_member_2_gender: props.formData.household_member_2_gender,
    household_member_3_gender: props.formData.household_member_3_gender,
    household_member_4_gender: props.formData.household_member_4_gender,
    household_member_5_gender: props.formData.household_member_5_gender,
  });
  const members = gatherAllHouseholdMembers(props.formData);
  const { formData, validationSchema } = props;
  const schema = props.validationSchema;

  return (
    <>
      <div
        id="navContainer"
        style={{
          height: 50,
          paddingTop: 14,
          paddingBottom: 10,
          background: "white",
          zIndex: 100,
          position: "sticky",
          top: "0",
          borderBottom: "1px solid #ebebeb",
          overflowX: "auto",
          overflowY: "hidden",
        }}
      >
        <b style={styles.sectionBtn}>
          <a href="#householdmembers">Household</a>
        </b>
        <b style={styles.sectionBtn}>
          <a href="#address">Address</a>
        </b>
        <b style={styles.sectionBtn}>
          <a href="#income">Income</a>
        </b>
        <b style={styles.sectionBtn}>
          <a href="#assets">Asset</a>
        </b>
        <b style={styles.sectionBtn}>
          <a href="#housing">Housing</a>
        </b>
        <b style={styles.sectionBtn}>
          <a href="#contact">Contact</a>
        </b>
        <b style={styles.sectionBtn}>
          <a href="#race">Race</a>
        </b>
        <b style={styles.sectionBtn}>
          <a href="#additional">Additional</a>
        </b>
      </div>
      <div>
        {isFieldInSchema("pref_lang", validationSchema) && (
          <>
            <FormRow><Typography variant="h6">Preferred Language</Typography></FormRow>
            {languages.map(({ code, en_name, native_name }, i) => (
              <RadioBasic
                key={i}
                label={`${en_name} ${native_name ? ` - ${native_name}` : ""}`}
                name="pref_lang"
                value={code}
                formData={formData}
                defaultChecked={formData.pref_lang === code}
              />
            ))}
          </>
        )}

        <FormRow><Typography variant="h5" id="householdmembers">Household Info</Typography></FormRow>

        {props.handleChangeHousehold ? (
          <ShouldRenderField name="household_count" vs={schema}>
            <FormRow>
              <Column width={12}>
                <p style={{ fontSize: 14 }}>
                  How many people will live in the apartment, including yourself?</p>
              </Column>
              <Select
                width={2}
                label="Household Size"
                name="household_count"
                formData={props.formData}
                options={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]}
                onChange={props.handleChangeHousehold}
              />
            </FormRow>
          </ShouldRenderField>) : (<div style={{ display: "none" }}>
          {/* hidden fields used for form parsing */}
          <Input name="household_count" formData={props.formData} />
          <Input name="submitted_at" formData={props.formData} />
          <RadioYesNo label="" name="is_complete" formData={props.formData} />
          <RadioYesNo label="" name="manually_entered" formData={props.formData} />
        </div>)}

        {members.map((_member, i) => (
          <div key={i} style={{ marginTop: 4 }}>
            {/* only show heading if we are requesting at least a first name */}
            <ShouldRenderField name={`household_member_${i}_first_name`} vs={schema}>
              <Typography variant="h6">Household Member {i + 1}</Typography>
            </ShouldRenderField>

            <FormRow>
              {isFieldInSchema(`household_member_${i}_first_name`, validationSchema) && (
                <Column width={6} sm={6}>
                  <Input
                    label="First Name"
                    name={`household_member_${i}_first_name`}
                    formData={props.formData}
                  />
                </Column>
              )}
              {isFieldInSchema(`household_member_${i}_middle_name`, validationSchema) && (
                <Column width={6} sm={6}>
                  <Input
                    label="Middle Name"
                    name={`household_member_${i}_middle_name`}
                    formData={props.formData}
                  />
                </Column>
              )}
              {isFieldInSchema(`household_member_${i}_last_name`, validationSchema) && (
                <Column width={6} sm={6}>
                  <Input
                    label="Last Name"
                    name={`household_member_${i}_last_name`}
                    formData={props.formData}
                  />
                </Column>
              )}
              {isFieldInSchema(`household_member_${i}_relation_to_app`, validationSchema) &&
                  i > 0 && (
                <Select
                  width={4}
                  label="Relationship to Head of Household"
                  name={`household_member_${i}_relation_to_app`}
                  formData={props.formData}
                  options={[
                    { label: "Head of Household", value: "Head of Household", disabled: true },
                    { label: "Co-head/Spouse", value: "Co-head/Spouse" },
                    { label: "Domestic Partner", value: "Domestic Partner" },
                    { label: "Foster Child", value: "Foster Child" },
                    { label: "Dependent Child", value: "Dependent Child" },
                    { label: "Unborn Child", value: "Unborn Child" },
                    { label: "Child (18+)", value: "Child (18+)" },
                    { label: "Child to be Adopted", value: "Child to be Adopted" },
                    { label: "Expectant Child of House Member", value: "Expectant Child of House Member" },
                    { label: "Parent", value: "Parent" },
                    { label: "Sibling", value: "Sibling" },
                    { label: "Cousin", value: "Cousin" },
                    { label: "Aunt", value: "Aunt" },
                    { label: "Uncle", value: "Uncle" },
                    { label: "Nephew", value: "Nephew" },
                    { label: "Niece", value: "Niece" },
                    { label: "Grandparent", value: "Grandparent" },
                    { label: "Great Grandparent", value: "Great Grandparent" },
                    { label: "In-law", value: "In-law" },
                    { label: "Friend", value: "Friend" },
                    { label: "Live in Caregiver", value: "Live in Caregiver" },
                    { label: "Other Family Member", value: "Other Family Member" },
                    { label: "Other", value: "Other" },
                  ]}
                />
              )}

              {isFieldInSchema(`household_member_${i}_gender`, validationSchema) && (
                <>
                  <Select
                    width={4}
                    margin="none"
                    label="Gender"
                    name={`household_member_${i}_gender`}
                    formData={props.formData}
                    options={["male", "female", "trans", "non-binary", "other"]}
                    onChangeAction={(_selector: any, e: any) => {
                      setState((oldState: any) => ({
                        ...oldState,
                        [`household_member_${i}_gender`]: e.target.value,
                      }));
                    }}
                  />
                  {["trans", "non-binary", "other"].includes(
                    state[`household_member_${i}_gender`],
                  ) && (
                    <Column width={4}>
                      <Input
                        label="What pronouns do you prefer?"
                        name={`household_member_${i}_gender_pronoun`}
                        formData={props.formData}
                      />
                    </Column>
                  )}
                </>
              )}

              {isFieldInSchema(`household_member_${i}_dob`, validationSchema) && (
                <>
                  <Column width={4}>
                    <InputDatePicker
                      label="Date of Birth"
                      placeholder="MM/DD/YYYY"
                      name={`household_member_${i}_dob`}
                      width={5}
                      formData={props.formData}
                    />
                  </Column>
                  {i > 0 && (
                    <Column width={6}>
                      <Checkbox
                        label="Unborn child, no date of birth yet"
                        name={`household_member_${i}_no_dob`}
                        style={{ fontSize: 20 }}
                        formData={props.formData}
                      />
                    </Column>
                  )}
                </>
              )}
            </FormRow>

            <ShouldRenderField name={`household_member_${i}_social_itin`} vs={schema}>
              <FormRow>
                <Select
                  width={5}
                  label="Citizen and Immigration Status Information"
                  name={`household_member_${i}_citizen_id_type`}
                  formData={props.formData}
                  options={[
                    "ssn_number",
                    "itin_number",
                    "ssn_itin_pending",
                    "ssn_provide_later",
                    "not_applicable",
                  ]}
                  onChangeAction={(_selector: any, e: any) => {
                    setState((oldState: any) => ({
                      ...oldState,
                      [`household_member_${i}_citizen_id_type`]: e.target.value,
                    }));
                  }}
                />

                {state[`household_member_${i}_citizen_id_type`] === "ssn_number" && (
                  <Column width={5}>
                    <Input
                      type="ssn"
                      label="Social Security Number"
                      name={`household_member_${i}_social`}
                      formData={props.formData}
                    />
                  </Column>
                )}

                {state[`household_member_${i}_citizen_id_type`] === "itin_number" && (
                  <Column width={5}>
                    <Input
                      type="ssn"
                      label="Tax Identification Number"
                      name={`household_member_${i}_tax_id_number`}
                      formData={props.formData}
                    />
                  </Column>
                )}

                {state[`household_member_${i}_citizen_id_type`] === "ssn_itin_pending" && (
                  <div>
                    <Select
                      width={3}
                      label="Document Type"
                      name={`household_member_${i}_ssn_itin_pending_type`}
                      formData={props.formData}
                      options={["SSN", "ITIN"]}
                    />
                    <Column width={3}>
                      <InputDatePicker
                        label="Expected Date Received"
                        placeholder="MM/DD/YYYY"
                        name={`household_member_${i}_ssn_itin_pending_expected_date`}
                        formData={props.formData}
                      />
                    </Column>
                  </div>
                )}
              </FormRow>
            </ShouldRenderField>

            {isFieldInSchema(`household_member_${i}_primary_phone`, validationSchema) && (
              <FormRow>
                <Column width={4}>
                  <Input
                    label="Household Member Phone"
                    name={`household_member_${i}_primary_phone`}
                    type="phone_number"
                    formData={props.formData}
                  />
                  <Checkbox
                    label="Household member does not have a phone number"
                    name={`household_member_${i}_no_primary_phone`}
                    formData={props.formData}
                  />
                </Column>
                <Select
                  width={3}
                  label="Phone Type"
                  name={`household_member_${i}_primary_phone_type`}
                  formData={props.formData}
                  options={["mobile", "landline"]}
                />
                <Column width={3}>
                  <p style={{ fontSize: 13, margin: "1px 0px 0px 0", paddingTop: "2px" }}>Ok to leave messages?</p>
                  <RadioYesNoSmall
                    name={`household_member_${i}_primary_phone_ok_to_leave_message`}
                    formData={props.formData}
                  />
                </Column>
              </FormRow>
            )}

            {isFieldInSchema(`household_member_${i}_secondary_phone`, validationSchema) &&
                i === 0 && ( // primary applicant
              <FormRow>
                <Column width={4}>
                  <Input
                    label="Alternative Applicant Phone"
                    name={`household_member_${i}_secondary_phone`}
                    type="phone_number"
                    formData={props.formData}
                  />
                  <Typography>
                    <i>
                          Only use contact information for yourself. Additional contacts such as a
                          social worker can be added later in the application.
                    </i>
                  </Typography>
                </Column>
                <Column width={2}>
                  <Input
                    label="Extension"
                    name={`household_member_${i}_secondary_phone_ext`}
                    formData={props.formData}
                  />
                </Column>
                <Select
                  width={3}
                  label="Phone Type"
                  name={`household_member_${i}_secondary_phone_type`}
                  formData={props.formData}
                  options={["mobile", "landline"]}
                />
                <Column width={3}>
                  <p style={{ fontSize: 13, margin: "1px 0 0px 0", paddingTop: "2px" }}>Ok to leave messages?</p>
                  <RadioYesNoSmall
                    name={`household_member_${i}_secondary_phone_ok_to_leave_message`}
                    formData={props.formData}
                  />
                </Column>
              </FormRow>
            )}

            {isFieldInSchema(`household_member_${i}_email`, validationSchema) && (
              <FormRow>
                <Column width={6}>
                  <Input
                    label="Email Address"
                    type="email"
                    name={`household_member_${i}_email`}
                    formData={props.formData}
                    autoComplete={`household_member_${i}_email`}
                  />
                  <Checkbox
                    label="Household member does not have an email address"
                    name={`household_member_${i}_no_email`}
                    formData={props.formData}
                  />
                </Column>
              </FormRow>
            )}

            {isFieldInSchema("applicant_prefered_contact_type", validationSchema) &&
                i === 0 && ( // primary applicant
              <FormRow>
                <Column width={7}>
                  <p>Do you prefer to communicate via email or mail?</p>
                </Column>
                <Column width={4}>
                  <div>
                    <RadioBasic
                      label="Mail"
                      name="applicant_prefered_contact_type"
                      value={"mail"}
                      formData={formData}
                      defaultChecked={formData.applicant_prefered_contact_type === "mail"}
                    />
                    <RadioBasic
                      label="Email"
                      name="applicant_prefered_contact_type"
                      value={"email"}
                      formData={formData}
                      defaultChecked={formData.applicant_prefered_contact_type === "email"}
                    />
                  </div>
                </Column>
              </FormRow>
            )}

            {isFieldInSchema(`household_member_${i}_student_type`, validationSchema) && (
              <FormRow>
                <Column width={7}>
                  <p>Is this household member a student?</p>
                </Column>
                <Column width={5}>
                  <div>
                    <RadioBasic
                      label="Full-time"
                      name={`household_member_${i}_student_type`}
                      value="full-time"
                      formData={props.formData}
                      defaultChecked={
                        props.formData[`household_member_${i}_student_type`] === "full-time"
                      }
                    />
                    <RadioBasic
                      label="Part-time"
                      name={`household_member_${i}_student_type`}
                      value="part-time"
                      formData={props.formData}
                      defaultChecked={
                        props.formData[`household_member_${i}_student_type`] === "part-time"
                      }
                    />
                    <span style={{ marginRight: -20 }}>
                      <RadioBasic
                        label="No"
                        name={`household_member_${i}_student_type`}
                        value="no"
                        formData={props.formData}
                        defaultChecked={
                          props.formData[`household_member_${i}_student_type`] === "no"
                        }
                      />
                    </span>
                  </div>
                </Column>
              </FormRow>
            )}
          </div>
        ))}
        <FormRow style={{ padding: 4 }}><Typography variant="h6" id="address">Address</Typography></FormRow>
        {isFieldInSchema("residence_address1", validationSchema) && (
          <div>
            <AddressGroup
              namespace="residence"
              addressLabel="Current Residence Address"
              formData={props.formData}
            />

            <FormRow>
              <Column width={12}>
                <p>Where do you want to receive mail from us?</p>
                <RadioBasic
                  name="mailing_address_type"
                  label="My residence address from above"
                  value="residence"
                  onChangeAction={(e: any) => {
                    setState((oldState: any) => ({ ...oldState,
                      mailingAddressType: e.value }));
                  }}
                  defaultChecked={props.formData.mailing_address_type === "residence"}
                />
                <br />
                <RadioBasic
                  name="mailing_address_type"
                  label="A different address"
                  value="mailing"
                  onChangeAction={(e: any) => {
                    setState((oldState: any) => ({ ...oldState,
                      mailingAddressType: e.value }));
                  }}
                  defaultChecked={props.formData.mailing_address_type === "mailing"}
                />
              </Column>
            </FormRow>

            <div className={state.mailingAddressType === "mailing" ? "collapse.show" : "collapse"}>
              <AddressGroup
                namespace="mailing"
                addressLabel="Mailing Address"
                formData={props.formData}
              />
            </div>
          </div>
        )}
        <FormRow><Typography variant="h6" id="income">Income Info</Typography></FormRow>

        <ShouldRenderField name="household_gross_annual_income" vs={schema}>
          <FormRow>
            <Column width={6}>
              <Input
                label="Household Total Gross Annual Income"
                name="household_gross_annual_income"
                type="currency_usd"
                formData={props.formData}
              />
            </Column>
          </FormRow>
        </ShouldRenderField>

        <ShouldRenderField name="household_is_employed" vs={schema}>
          <RadioYesNo
            label="Are you or anyone who will be living with you employed?"
            name="household_is_employed"
            formData={props.formData}
          />
        </ShouldRenderField>

        <ShouldRenderField name="household_is_self_employed" vs={schema}>
          <div>
            <RadioYesNo
              label="Are you or anyone who will be living with you self-employed?"
              name="household_is_self_employed"
              formData={props.formData}
            />
          </div>
        </ShouldRenderField>

        <ShouldRenderField name="household_is_receiving_unemployment" vs={schema}>
          <div>
            <RadioYesNo
              label="Are you or anyone who will be living with you receiving unemployment benefits?"
              name="household_is_receiving_unemployment"
              formData={props.formData}
            />
          </div>
        </ShouldRenderField>

        <ShouldRenderField name="household_is_receiving_vet_income" vs={schema}>
          <div>
            <RadioYesNo
              label="Are you or anyone who will be living with you receiving Veteran's Administration, GI Bill, or National Guard/Military benefits/income?"
              name="household_is_receiving_vet_income"
              formData={props.formData}
            />
          </div>
        </ShouldRenderField>

        <ShouldRenderField name="household_is_receiving_social_security" vs={schema}>
          <div>
            <RadioYesNo
              label="Are you or anyone who will be living with you receiving social security payments?"
              name="household_is_receiving_social_security"
              formData={props.formData}
            />
          </div>
        </ShouldRenderField>

        <ShouldRenderField name="household_is_receiving_gifts" vs={schema}>
          <div>
            <RadioYesNo
              label="Are you or anyone who will be living with you receiving cash contributions of gifts including rent or utility payments, on an ongoing basis from persons not living with you?"
              name="household_is_receiving_gifts"
              formData={props.formData}
            />
          </div>
        </ShouldRenderField>

        <ShouldRenderField name="household_is_receiving_ssi" vs={schema}>
          <div>
            <RadioYesNo
              label="Are you or anyone who will be living with you receiving periodic Supplemental Security Income (SSI)?"
              name="household_is_receiving_ssi"
              formData={props.formData}
            />
          </div>
        </ShouldRenderField>

        <ShouldRenderField name="household_is_receiving_disability_benefits" vs={schema}>
          <div>
            <RadioYesNo
              label="Are you or anyone who will be living with you receiving disability or death benefits other than Social Security?"
              name="household_is_receiving_disability_benefits"
              formData={props.formData}
            />
          </div>
        </ShouldRenderField>

        <ShouldRenderField name="household_is_receiving_public_assistance_income" vs={schema}>
          <div>
            <RadioYesNo
              label="Are you or anyone who will be living with you receiving Public Assistance Income (examples: TANF, AFDC)? "
              name="household_is_receiving_public_assistance_income"
              formData={props.formData}
            />
          </div>
        </ShouldRenderField>

        <ShouldRenderField name="household_is_entitled_to_child_support" vs={schema}>
          <div>
            <RadioYesNo
              label="Are you or anyone else who will be living with you entitled to receive child support payments? "
              name="household_is_entitled_to_child_support"
              formData={props.formData}
            />
          </div>
        </ShouldRenderField>

        <ShouldRenderField name="household_is_receiving_child_support" vs={schema}>
          <div>
            <RadioYesNo
              label="Are you or anyone who will be living with you currently receiving child support payments?"
              name="household_is_receiving_child_support"
              formData={props.formData}
            />
          </div>
        </ShouldRenderField>

        <ShouldRenderField name="household_is_receiving_alimony" vs={schema}>
          <div>
            <RadioYesNo
              label="Are you or anyone who will be living with you receiving alimony/spousal support payments?"
              name="household_is_receiving_alimony"
              formData={props.formData}
            />
          </div>
        </ShouldRenderField>

        <ShouldRenderField name="household_is_receiving_periodic_payments" vs={schema}>
          <div>
            <RadioYesNo
              label="Are you or anyone who will be living with you receiving periodic payments from trusts, annuities, inheritance, retirement funds or pensions, insurance policies, or lottery winnings?"
              name="household_is_receiving_periodic_payments"
              formData={props.formData}
            />
          </div>
        </ShouldRenderField>

        <ShouldRenderField name="household_is_receiving_property_income" vs={schema}>
          <div>
            <RadioYesNo
              label="Are you or anyone who will be living with you receiving income from real or personal property? "
              name="household_is_receiving_property_income"
              formData={props.formData}
            />
          </div>
        </ShouldRenderField>

        <ShouldRenderField name="household_is_receiving_non_loan_financial_aid" vs={schema}>
          <div>
            <RadioYesNo
              label="Are you or anyone who will be living with you receiving student financial aid (public or private, not including student loans)?"
              name="household_is_receiving_non_loan_financial_aid"
              formData={props.formData}
            />
          </div>
        </ShouldRenderField>

        <ShouldRenderField name="household_is_receiving_workers_comp" vs={schema}>
          <div>
            <RadioYesNo
              label="Do you or anyone who will be living with you receive Worker’s Compensation Payments?"
              name="household_is_receiving_workers_comp"
              formData={props.formData}
            />
          </div>
        </ShouldRenderField>

        <ShouldRenderField name="household_is_receiving_income_not_listed" vs={schema}>
          <div>
            <RadioYesNo
              label="Do you or anyone who will be living with you have any source of income not listed above?"
              name="household_is_receiving_income_not_listed"
              formData={props.formData}
            />
          </div>
        </ShouldRenderField>

        <FormRow><Typography variant="h6" id="assets">Asset Info</Typography></FormRow>

        <ShouldRenderField name="household_has_checking_account" vs={schema}>
          <div>
            <RadioYesNo
              label="Do you or anyone who will be living with you have a checking account?"
              name="household_has_checking_account"
              formData={props.formData}
            />
            {members.map((_member, i) => (
              <div key={i}>
                {[0, 1, 2].map((j) => {
                  const fieldIsVisable = state[`household_member_${i}_checking_inc`] >= j;
                  const isFilled = !!formData[`household_member_${i}_checking_${j}_bank_name`];
                  if (fieldIsVisable || isFilled) {
                    return (
                      <div key={j}>
                        <FormRow style={{ marginTop: 0 }}>
                          <Column width={7}>
                            <ShouldRenderField
                              name={`household_member_${i}_checking_${j}_bank_name`}
                              vs={schema}
                            >
                              <Input
                                label={`Household member ${i + 1} Bank Name #${j + 1}`}
                                name={`household_member_${i}_checking_${j}_bank_name`}
                                formData={props.formData}
                              />
                            </ShouldRenderField>
                          </Column>
                        </FormRow>
                        <FormRow>
                          <Column width={4}>
                            <ShouldRenderField
                              name={`household_member_${i}_checking_${j}_balance`}
                              vs={schema}
                            >
                              <Input
                                label={`Total Checking Account Balance #${j + 1}`}
                                name={`household_member_${i}_checking_${j}_balance`}
                                type="currency_usd"
                                formData={props.formData}
                              />
                            </ShouldRenderField>
                          </Column>
                        </FormRow>
                        <ShouldRenderField
                          name={`household_member_${i}_checking_${j}_is_joint_account`}
                          vs={schema}
                        >
                          <FormRow>
                            <Column width={3}>
                              <p>Is this a joint account?</p>
                              <RadioYesNoSmall
                                name={`household_member_${i}_checking_${j}_is_joint_account`}
                                formData={props.formData}
                              />
                            </Column>
                            <Column width={4} style={{ margin: "7px  0 0 -35px" }}>
                              <p>If yes, do not add the same account under a different name.</p>
                            </Column>
                          </FormRow>
                        </ShouldRenderField>
                        {formData[`household_member_${i}_checking_${j}_is_joint_account`] && (
                          <FormRow>
                            <p>Who else is listed on the account?</p>
                            <Column width={7}>
                              <Input
                                label={`Joint Account Holder Name #${j + 1}`}
                                name={
                                  `household_member_${i}_checking_${j}_joint_account_holder_name`}
                                formData={props.formData}
                              />
                            </Column>
                          </FormRow>
                        )}
                      </div>
                    );
                  }
                  return null;
                })}
                <ShouldRenderField name={`household_member_${i}_checking_1_balance`} vs={schema}>
                  <FormRow>
                    <Column width={12}>
                      {state[`household_member_${i}_checking_inc`] < 2 && (
                        <button
                          type="button"
                          className="btn btn-small btn-primary"
                          onClick={() => {
                            const fieldName = `household_member_${i}_checking_inc`;
                            setState((oldState: any) => ({
                              ...oldState,
                              [fieldName]: state[fieldName] + 1,
                            }));
                          }}
                        >
                          Add Another Checking Account
                        </button>
                      )}
                      <hr />
                    </Column>
                  </FormRow>
                </ShouldRenderField>
              </div>
            ))}
          </div>
        </ShouldRenderField>
        <ShouldRenderField name="household_has_savings_account" vs={schema}>
          <div>
            <RadioYesNo
              label="Do you or anyone who will be living with you have a savings account?"
              name="household_has_savings_account"
              formData={props.formData}
            />
            {members.map((_member, i) => (
              <div key={i}>
                {[0, 1, 2].map((j) => {
                  const fieldIsVisable = state[`household_member_${i}_savings_inc`] >= j;
                  const isFilled = !!formData[`household_member_${i}_savings_${j}_bank_name`];
                  if (fieldIsVisable || isFilled) {
                    return (
                      <div key={j}>
                        <FormRow style={{ marginTop: 0 }}>
                          <Column width={7}>
                            <ShouldRenderField
                              name={`household_member_${i}_savings_${j}_bank_name`}
                              vs={schema}
                            >
                              <Input
                                label={`Household member ${i + 1} Bank Name #${j + 1}`}
                                name={`household_member_${i}_savings_${j}_bank_name`}
                                formData={props.formData}
                              />
                            </ShouldRenderField>
                          </Column>
                        </FormRow>
                        <FormRow>
                          <Column width={4}>
                            <ShouldRenderField
                              name={`household_member_${i}_savings_${j}_balance`}
                              vs={schema}
                            >
                              <Input
                                label={`Total Savings Account Balance #${j + 1}`}
                                name={`household_member_${i}_savings_${j}_balance`}
                                type="currency_usd"
                                formData={props.formData}
                              />
                            </ShouldRenderField>
                          </Column>
                        </FormRow>
                        <ShouldRenderField
                          name={`household_member_${i}_savings_${j}_is_joint_account`}
                          vs={schema}
                        >
                          <FormRow>
                            <Column width={3}>
                              <p>Is this a joint account?</p>
                              <RadioYesNoSmall
                                name={`household_member_${i}_savings_${j}_is_joint_account`}
                                persistTableName="interests"
                                formData={props.formData}
                              />
                            </Column>
                            <Column width={4}>
                              <p>If yes, do not add the same account under a different name.</p>
                            </Column>
                          </FormRow>
                        </ShouldRenderField>
                        {formData[`household_member_${i}_savings_${j}_is_joint_account`] && (
                          <FormRow>
                            <p>Who else is listed on the account?</p>
                            <Column width={7}>
                              <Input
                                label={`Joint Account Holder Name #${j + 1}`}
                                name={
                                  `household_member_${i}_savings_${j}_joint_account_holder_name`}
                                formData={props.formData}
                                persistTableName="interests"
                                validationSchema={validationSchema}
                              />
                            </Column>
                          </FormRow>
                        )}
                      </div>
                    );
                  }
                  return null;
                })}
                <ShouldRenderField name={`household_member_${i}_savings_1_balance`} vs={schema}>
                  <FormRow>
                    <Column width={12}>
                      {state[`household_member_${i}_savings_inc`] < 2 && (
                        <button
                          type="button"
                          className="btn btn-small btn-primary"
                          onClick={() => {
                            const fieldName = `household_member_${i}_savings_inc`;
                            setState((oldState: any) => ({
                              ...oldState,
                              [fieldName]: state[fieldName] + 1,
                            }));
                          }}
                        >
                          Add Another Savings Account
                        </button>
                      )}
                      <hr />
                    </Column>
                  </FormRow>
                </ShouldRenderField>
              </div>
            ))}
          </div>
        </ShouldRenderField>
        <ShouldRenderField name="household_has_revok_trust" vs={schema}>
          <div>
            <RadioYesNo
              label="Do you or anyone who will be living with you have a revocable trust?"
              name="household_has_revok_trust"
              formData={props.formData}
            />
            {members.map((_member, i) => (
              <FormRow key={i}>
                <Column width={6}>
                  <ShouldRenderField name={`household_member_${i}_revok_trust_value`} vs={schema}>
                    <Input
                      key={i}
                      type="currency_usd"
                      label={`Household member ${i + 1} Revocable Trust Value`}
                      name={`household_member_${i}_revok_trust_value`}
                      formData={props.formData}
                    />
                  </ShouldRenderField>
                </Column>
              </FormRow>
            ))}
          </div>
        </ShouldRenderField>
        <ShouldRenderField name="household_has_real_estate" vs={schema}>
          <div>
            <RadioYesNo
              label="Do you or anyone who will be living with you own real estate? "
              name="household_has_real_estate"
              formData={props.formData}
            />
            {members.map((_member, i) => (
              <FormRow key={i}>
                <Column width={6}>
                  <ShouldRenderField name={`household_member_${i}_real_estate_value`} vs={schema}>
                    <Input
                      key={i}
                      type="currency_usd"
                      label={`Household member ${i + 1} Real Estate Value`}
                      name={`household_member_${i}_real_estate_value`}
                      formData={props.formData}
                    />
                  </ShouldRenderField>
                </Column>
              </FormRow>
            ))}
          </div>
        </ShouldRenderField>
        <ShouldRenderField name="household_has_stocks_treasuries" vs={schema}>
          <div>
            <RadioYesNo
              label="Do you or anyone who will be living with you own stocks, bonds, or Treasury Bills?"
              name="household_has_stocks_treasuries"
              formData={props.formData}
            />
            {members.map((_member, i) => (
              <FormRow key={i} style={{ marginBottom: 20 }}>
                <Column width={6}>
                  <ShouldRenderField
                    name={`household_member_${i}_stock_bond_treasury_value`} vs={schema}>
                    <Input
                      label={`Household member ${i + 1} Stock / Bond / Treasury Bond Value`}
                      name={`household_member_${i}_stock_bond_treasury_value`}
                      type="currency_usd"
                      formData={props.formData}
                    />
                  </ShouldRenderField>
                  <ShouldRenderField name={`household_member_${i}_brokerage_name`} vs={schema}>
                    <Input
                      label="Brokerage Name"
                      name={`household_member_${i}_brokerage_name`}
                      formData={props.formData}
                    />
                  </ShouldRenderField>
                </Column>
              </FormRow>
            ))}
          </div>
        </ShouldRenderField>
        <ShouldRenderField name="household_has_cd_money_market" vs={schema}>
          <div>
            <RadioYesNo
              label="Do you or anyone who will be living with you have Certificate of Deposits (CDs) or a Money Market Account?"
              name="household_has_cd_money_market"
              formData={props.formData}
            />
            {members.map((_member, i) => (
              <div key={i} style={{ marginBottom: 0 }}>
                <FormRow style={{ marginTop: 10 }}>
                  <Column width={7}>
                    <ShouldRenderField
                      name={`household_member_${i}_cd_money_market_bank_name`}
                      vs={schema}
                    >
                      <Input
                        label={`$Household member ${i + 1} Bank Name`}
                        name={`household_member_${i}_cd_money_market_bank_name`}
                        formData={props.formData}
                      />
                    </ShouldRenderField>
                  </Column>
                </FormRow>
                <FormRow>
                  <Column width={4}>
                    <ShouldRenderField
                      name={`household_member_${i}_cd_money_market_value`} vs={schema}>
                      <Input
                        label="CD / Money Market Account Value"
                        name={`household_member_${i}_cd_money_market_value`}
                        type="currency_usd"
                        formData={props.formData}
                      />
                    </ShouldRenderField>
                  </Column>
                </FormRow>

                <ShouldRenderField
                  name={`household_member_${i}_cd_money_market_is_joint_account`}
                  vs={schema}
                >
                  <div>
                    <FormRow>
                      <Column width={3}>
                        <p>Is this a joint account?</p>
                        <RadioYesNoSmall
                          name={`household_member_${i}_cd_money_market_is_joint_account`}
                          formData={props.formData}
                        />
                      </Column>
                      <Column width={4} style={{ margin: "7px  0 0 -35px" }}>
                        <p>If yes, do not add the same account under a different name.</p>
                      </Column>
                    </FormRow>
                    {formData[`household_member_${i}_cd_money_market_is_joint_account`] && (
                      <FormRow>
                        <p>Who else is listed on the account?</p>
                        <Column width={7}>
                          <Input
                            label="Joint Account Holder Name"
                            name={`household_member_${i}_cd_money_market_joint_account_holder_name`}
                            formData={props.formData}
                          />
                        </Column>
                      </FormRow>
                    )}
                  </div>
                </ShouldRenderField>
              </div>
            ))}
          </div>
        </ShouldRenderField>
        <ShouldRenderField name="household_has_ira_401k_lump_pension" vs={schema}>
          <div>
            <RadioYesNo
              label="Do you or anyone who will be living with you have a IRA/Lump Sum Pension/Keogh Account/401K?"
              name="household_has_ira_401k_lump_pension"
              formData={props.formData}
            />
            {members.map((_member, i) => (
              <div key={i} style={{ marginBottom: 0 }}>
                <ShouldRenderField
                  name={`household_member_${i}_ira_401k_lump_pension_bank_name`}
                  vs={schema}
                >
                  <FormRow style={{ marginTop: 10 }}>
                    <Column width={7}>
                      <Input
                        label={`Household member ${i + 1} Bank Name`}
                        name={`household_member_${i}_ira_401k_lump_pension_bank_name`}
                        formData={props.formData}
                      />
                    </Column>
                  </FormRow>
                </ShouldRenderField>
                <ShouldRenderField
                  name={`household_member_${i}_ira_401k_lump_pension_balance`}
                  vs={schema}
                >
                  <FormRow>
                    <Column width={4}>
                      <Input
                        label="IRA / Pension / Keogh / 401k Value"
                        name={`household_member_${i}_ira_401k_lump_pension_balance`}
                        type="currency_usd"
                        formData={props.formData}
                      />
                    </Column>
                  </FormRow>
                </ShouldRenderField>
                <ShouldRenderField
                  name={`household_member_${i}_ira_401k_lump_pension_is_joint_account`}
                  vs={schema}
                >
                  <FormRow>
                    <Column width={3}>
                      <p>Is this a joint account?</p>
                      <RadioYesNoSmall
                        name={`household_member_${i}_ira_401k_lump_pension_is_joint_account`}
                        persistTableName="interests"
                        formData={props.formData}
                      />
                    </Column>
                    <Column width={4} style={{ margin: "7px  0 0 -35px" }}>
                      <p>If yes, do not add the same account under a different name.</p>
                    </Column>
                  </FormRow>
                </ShouldRenderField>
                {formData[`household_member_${i}_ira_401k_lump_pension_is_joint_account`] && (
                  <FormRow>
                    <p>Who else is listed on the account?</p>
                    <Column width={7}>
                      <Input
                        label="Joint Account Holder Name"
                        name={
                          `household_member_${i}_ira_401k_lump_pension_joint_account_holder_name`}
                        formData={props.formData}
                      />
                    </Column>
                  </FormRow>
                )}
              </div>
            ))}
          </div>
        </ShouldRenderField>
        <ShouldRenderField name="household_has_whole_life_policy" vs={schema}>
          <div>
            <RadioYesNo
              label="Do you or anyone who will be living with you have a whole life insurance policy?"
              name="household_has_whole_life_policy"
              formData={props.formData}
            />
            {members.map((_member, i) => (
              <FormRow key={i}>
                <Column width={6}>
                  <ShouldRenderField
                    name={`household_member_${i}_whole_life_insurance_value`}
                    vs={schema}
                  >
                    <Input
                      key={i}
                      label={`Household member ${i + 1} Whole Life Insurance Value`}
                      name={`household_member_${i}_whole_life_insurance_value`}
                      type="currency_usd"
                      formData={props.formData}
                    />
                  </ShouldRenderField>
                </Column>
              </FormRow>
            ))}
          </div>
        </ShouldRenderField>
        <ShouldRenderField name="household_has_cash" vs={schema}>
          <div>
            <RadioYesNo
              label="Do you or anyone who will be living with you have cash on hand? "
              name="household_has_cash"
              formData={props.formData}
            />
            {members.map((_member, i) => (
              <FormRow key={i}>
                <Column width={6}>
                  <ShouldRenderField name={`household_member_${i}_cash_value`} vs={schema}>
                    <Input
                      key={i}
                      label={`Household member ${i + 1} Cash on Hand Value`}
                      name={`household_member_${i}_cash_value`}
                      type="currency_usd"
                      formData={props.formData}
                    />
                  </ShouldRenderField>
                </Column>
              </FormRow>
            ))}
          </div>
        </ShouldRenderField>
        <ShouldRenderField name="household_has_disposed_of_assets" vs={schema}>
          <div>
            <RadioYesNo
              label="Have you or anyone else who will be living with you disposed of assets (i.e. gave away money/assets) for less than the fair market value in the past 2 years? (Do not include furniture or cars) "
              name="household_has_disposed_of_assets"
              formData={props.formData}
            />
            {members.map((_member, i) => (
              <FormRow key={i}>
                <Column width={6}>
                  <ShouldRenderField
                    name={`household_member_${i}_disposed_assets_value`} vs={schema}>
                    <Input
                      key={i}
                      label={`Household member ${i + 1} Disposed Assets Value`}
                      name={`household_member_${i}_disposed_assets_value`}
                      type="currency_usd"
                      formData={props.formData}
                    />
                  </ShouldRenderField>
                </Column>
              </FormRow>
            ))}
          </div>
        </ShouldRenderField>
        <ShouldRenderField name="household_has_assets_not_listed" vs={schema}>
          <div>
            <RadioYesNo
              label="Do you or anyone who will be living with you have any source of assets not listed above?"
              name="household_has_assets_not_listed"
              formData={props.formData}
            />
            {members.map((_member, i) => (
              <FormRow key={i}>
                {[0, 1, 2].map((j) => {
                  const fieldIsVisable = state[`household_member_${i}_asset_notlist_inc`] >= j;
                  const isFilled = !!formData[`household_member_${i}_assets_not_listed_${j}_value`];
                  if (fieldIsVisable || isFilled) {
                    return (
                      <div key={j}>
                        <ShouldRenderField
                          name={`household_member_${i}_assets_not_listed_${j}_source`}
                          vs={schema}
                        >
                          <div>
                            <Column width={6}>
                              <Input
                                label={`Household member ${i + 1} Asset #${j + 1} Source`}
                                name={`household_member_${i}_assets_not_listed_${j}_source`}
                                formData={props.formData}
                              />
                            </Column>
                            <Column width={6}>
                              <Input
                                type="currency_usd"
                                label="Asset Value"
                                name={`household_member_${i}_assets_not_listed_${j}_value`}
                                formData={props.formData}
                              />
                            </Column>
                          </div>
                        </ShouldRenderField>
                      </div>
                    );
                  }
                  return null;
                })}

                <ShouldRenderField
                  name={`household_member_${i}_assets_not_listed_0_source`} vs={schema}>
                  <Column width={12}>
                    {state[`household_member_${i}_asset_notlist_inc`] < 2 && (
                      <button
                        type="button"
                        className="btn btn-small btn-primary"
                        onClick={() => {
                          const fieldName = `household_member_${i}_asset_notlist_inc`;
                          setState((oldState: any) => ({
                            ...oldState,
                            [fieldName]: state[fieldName] + 1,
                          }));
                        }}
                      >
                        Add Another Asset
                      </button>
                    )}
                  </Column>
                </ShouldRenderField>
              </FormRow>
            ))}
          </div>
        </ShouldRenderField>
        <FormRow><Typography variant="h6" id="housing">Housing Info</Typography></FormRow>
        <ShouldRenderField name="applicant_homeless_does_not_have_landlord" vs={schema}>
          <FormRow>
            <Column width={12}>
              <Checkbox
                label="I am homeless and do not have a landlord "
                name="applicant_homeless_does_not_have_landlord"
                formData={props.formData}
              />
            </Column>
          </FormRow>
        </ShouldRenderField>
        <FormRow>
          <ShouldRenderField name="landlord_first_name" vs={schema}>
            <Column width={6}>
              <Input
                label="Landlord First Name"
                name="landlord_first_name"
                formData={props.formData}
              />
            </Column>
          </ShouldRenderField>
          <ShouldRenderField name="landlord_last_name" vs={schema}>
            <Column width={6}>
              <Input
                label="Landlord Last Name"
                name="landlord_last_name"
                formData={props.formData}
              />
            </Column>
          </ShouldRenderField>
        </FormRow>
        <FormRow>
          <ShouldRenderField name="landlord_has_unknown_address" vs={schema}>
            <Column width={12}>
              <Checkbox
                label="I don’t know my landlord’s address"
                name="landlord_has_unknown_address"
                formData={props.formData}
              />
            </Column>
          </ShouldRenderField>
        </FormRow>
        <ShouldRenderField name="landlord_address1" vs={schema}>
          <AddressGroup
            namespace="landlord"
            addressLabel="Landlord Address"
            formData={props.formData}
          />
        </ShouldRenderField>
        <ShouldRenderField name="landlord_primary_phone" vs={schema}>
          <FormRow>
            <Column width={6}>
              <Input
                label="Landlord Telephone"
                name="landlord_primary_phone"
                formData={props.formData}
                type="phone_number"
              />
            </Column>
            <Select
              width={3}
              label="Phone Type"
              name="landlord_primary_phone_type"
              options={["landline", "mobile", "other"]}
              formData={props.formData}
            />

            <Column width={3}>
              <p style={{ fontSize: 13, margin: "4px 0 9px 0" }}>Ok to leave messages?</p>
              <RadioYesNoSmall name="landlord_ok_to_leave_message" formData={props.formData} />
            </Column>

            <Column width={12}>
              <Checkbox
                label="I don’t know my landlord’s phone number or she/he does not have a phone number"
                name="landlord_has_unknown_phone"
                formData={props.formData}
              />
            </Column>
          </FormRow>
        </ShouldRenderField>
        <ShouldRenderField name="landlord_email" vs={schema}>
          <FormRow>
            <Column width={6}>
              <Input label="Landlord Email" name="landlord_email" formData={props.formData} />
            </Column>
            <Select
              width={3}
              label="Reason for Moving"
              name="reason_for_moving"
              options={[
                "Want more space",
                "Rent too high",
                "Family Size Change",
                "Living with Family",
                "Bad Housing conditions",
                "Health Reasons",
                "Homeless",
                "New job",
                "Do not like neighborhood",
                "Other",
              ]}
              formData={props.formData}
            />
          </FormRow>
        </ShouldRenderField>
        <ShouldRenderField name="applicant_total_monthly_rent" vs={schema}>
          <FormRow>
            <Column width={3}>
              <Input
                label="Total Monthly Rent"
                name="applicant_total_monthly_rent"
                formData={props.formData}
              />
            </Column>
            <Column width={3}>
              <p style={{ fontSize: 13, margin: "4px 0 9px 0" }}>Is rent subsidized?</p>
              <RadioYesNoSmall name="is_rent_subsidized" formData={props.formData} />
            </Column>
            <Column width={3}>
              <Input
                label="Your contribution to Rent"
                name="applicant_contribution_to_rent"
                formData={props.formData}
              />
            </Column>
          </FormRow>
        </ShouldRenderField>
        <FormRow><Typography variant="h6" id="contact">Optional Contact</Typography></FormRow>
        <ShouldRenderField name="contact_deny_information" vs={schema}>
          <FormRow>
            <Column width={12}>
              <Checkbox
                label="Check this box if you choose not to provide this information"
                name="contact_deny_information"
                formData={props.formData}
              />
            </Column>
          </FormRow>
        </ShouldRenderField>
        <FormRow>
          <ShouldRenderField name="contact_name" vs={schema}>
            <Column width={8}>
              <Input
                label="Name of Additional Contact Person or Organization"
                name="contact_name"
                formData={props.formData}
              />
            </Column>
          </ShouldRenderField>
          <ShouldRenderField name="contact_relation" vs={schema}>
            <Select
              width={4}
              label="Optional Contact Type"
              name="contact_relation"
              options={[
                "Friend",
                "Family Member",
                "Case Manager or Housing Counselor",
                "Other",
                "I don't have an alternate contact",
              ]}
              formData={props.formData}
            />
          </ShouldRenderField>
        </FormRow>
        <ShouldRenderField name="contact_address1" vs={schema}>
          <AddressGroup
            namespace="contact"
            addressLabel="Contact Address"
            formData={props.formData}
          />
        </ShouldRenderField>
        <ShouldRenderField name="contact_primary_phone" vs={schema}>
          <FormRow>
            <Column width={4}>
              <Input
                label="Optional Contact Phone Number"
                name="contact_primary_phone"
                type="phone_number"
                formData={props.formData}
              />
            </Column>
            <Column width={2}>
              <Input label="Extension" name="contact_primary_phone_ext" formData={props.formData} />
            </Column>
            <Select
              width={3}
              label="Phone Type"
              name="contact_primary_phone_type"
              options={["landline", "mobile", "other"]}
              formData={props.formData}
            />
            <Column width={3}>
              <p style={{ fontSize: 13, margin: "4px 0 0px 0" }}>Ok to leave messages?</p>
              <RadioYesNoSmall
                name="contact_primary_phone_ok_to_leave_message"
                formData={props.formData}
              />
            </Column>
          </FormRow>
        </ShouldRenderField>
        <ShouldRenderField name="contact_secondary_phone" vs={schema}>
          <FormRow>
            <Column width={6}>
              <Input
                label="Additional Optional Contact Phone Number"
                name="contact_secondary_phone"
                type="phone_number"
                formData={props.formData}
              />
            </Column>
            <Select
              width={3}
              label="Phone Type"
              name="contact_secondary_phone_type"
              options={["landline", "mobile", "other"]}
              formData={props.formData}
            />
            <Column width={3}>
              <p style={{ fontSize: 13, margin: "4px 0 9px 0" }}>Ok to leave messages?</p>
              <RadioYesNoSmall
                name="contact_secondary_phone_ok_to_leave_message"
                formData={props.formData}
              />
            </Column>
          </FormRow>
        </ShouldRenderField>
        <ShouldRenderField name="contact_email" vs={schema}>
          <FormRow>
            <Column width={6}>
              <Input
                label="Optional Contact Email"
                name="contact_email"
                type="email"
                formData={props.formData}
                autoComplete="contact_email"
              />
            </Column>
          </FormRow>
        </ShouldRenderField>
        <ShouldRenderField name="contact_reasons" vs={schema}>
          <FormRow style={{ paddingBottom: 20 }}>
            <p style={{ fontSize: 13, margin: "5px 0px 10px 8px" }}>
              Reason for Contact (check all that apply):
            </p>
            <Column width={6}>
              <Checkbox
                label="Send application receipt & inform about waitlist updates"
                name="contact_reason_receipt"
                formData={props.formData}
              />
              <Checkbox
                label="Emergency"
                name="contact_reason_emergency"
                formData={props.formData}
              />
              <Checkbox
                label="Unable to contact you"
                name="contact_reason_unable_to_contact"
                formData={props.formData}
              />
              <Checkbox
                label="Termination of rental assistance"
                name="contact_reason_termination_of_rental_assist"
                formData={props.formData}
              />
              <Checkbox
                label="Eviction from unit"
                name="contact_reason_eviction_from_unit"
                formData={props.formData}
              />
              <Checkbox
                label="Late payment of rent"
                name="contact_reason_late_payment_of_rent"
                formData={props.formData}
              />
              <Checkbox
                label="Assist with Recertification"
                name="contact_reason_assist_with_recertification"
                formData={props.formData}
              />
              <Checkbox
                label="Change in lease terms"
                name="contact_reason_change_in_lease_terms"
                formData={props.formData}
              />
              <Checkbox
                label="Change in house rules"
                name="contact_reason_change_in_house_rules"
                formData={props.formData}
              />
              <Checkbox label="Other" name="contact_reason_other" formData={props.formData} />
            </Column>
            <div style={{ height: 15 }} />
          </FormRow>
        </ShouldRenderField>
        <FormRow><Typography variant="h6" id="race">Race and Ethnicity</Typography></FormRow>
        {gatherAllHouseholdMembers(props.formData).map((member, i) => (
          <ShouldRenderField name={`household_member_${i}_ethnic_category`} vs={schema} key={i}>
            <div>
              <p>Household member: {member.name}</p>
              <FormRow>
                <Column width={12}>
                  <RadioBasic
                    label="Hispanic"
                    name={`household_member_${i}_ethnic_category`}
                    value="Hispanic or Latino"
                    formData={props.formData}
                    defaultChecked={
                      props.formData[`household_member_${i}_ethnic_category`] ===
                      "Hispanic or Latino"
                    }
                  />
                  <RadioBasic
                    label="Non-Hispanic"
                    name={`household_member_${i}_ethnic_category`}
                    value="Not-Hispanic or Latino"
                    formData={props.formData}
                    defaultChecked={
                      props.formData[`household_member_${i}_ethnic_category`] ===
                      "Not-Hispanic or Latino"
                    }
                  />
                </Column>
              </FormRow>

              <p style={{ fontSize: 12 }}>Racial Categories (check all that apply):</p>
              <FormRow>
                <Column width={12}>
                  <Checkbox
                    label="American Indian or Alaskan Native"
                    name={`household_member_${i}_race_amer_indian_alaskan_native`}
                    formData={props.formData}
                  />
                  <Checkbox
                    label="Asian"
                    name={`household_member_${i}_race_asian`}
                    formData={props.formData}
                  />
                  <Checkbox
                    label="Black or African American"
                    name={`household_member_${i}_race_african_american`}
                    formData={props.formData}
                  />
                  <Checkbox
                    label="Native Hawaiian or other Pacific Islander"
                    name={`household_member_${i}_race_native_hawaiian_or_other_pac_islander`}
                    formData={props.formData}
                  />
                  <Checkbox
                    label="White"
                    name={`household_member_${i}_race_white`}
                    formData={props.formData}
                  />
                  <Checkbox
                    label="Other"
                    name={`household_member_${i}_race_other`}
                    formData={props.formData}
                  />
                  <br />
                  <Checkbox
                    label="I choose not to provide this information"
                    name={`household_member_${i}_race_decline`}
                    formData={props.formData}
                  />
                </Column>
              </FormRow>
            </div>
          </ShouldRenderField>
        ))}
        <div>
          <FormRow><Typography variant="h6" id="additional">Additional Info</Typography></FormRow>

          <div>
            <p style={{ marginBottom: 1 }}>Which ways can we contact you?</p>
            <FormRow>
              <Column width={12}>
                <Checkbox
                  inline
                  label="Phone"
                  name="contact_method_phone"
                  formData={props.formData}
                />
                <Checkbox
                  inline
                  label="Text"
                  name="contact_method_sms"
                  formData={props.formData}
                />
                <Checkbox
                  inline
                  label="Email"
                  name="contact_method_email"
                  formData={props.formData}
                />
                <Checkbox
                  inline
                  label="Mail"
                  name="contact_method_mail"
                  formData={props.formData}
                />
              </Column>
            </FormRow>
          </div>

          <ShouldRenderField name="pref_move_in_date" vs={schema}>
            <FormRow style={{ marginTop: -10 }}>
              <Column width={8}>
                <InputDatePicker
                  label="Preferred Move-In Date"
                  placeholder="MM/DD/YYYY"
                  name={"pref_move_in_date"}
                  width={5}
                  formData={props.formData}
                />
              </Column>
            </FormRow>
          </ShouldRenderField>

          <ShouldRenderField name="unit_size" vs={schema}>
            <FormRow>
              <Column width={12}>
                <label style={{ display: "block", fontWeight: 600 }}>Unit Sizes</label>

                {getUnitSizeOptions(schema).map(({ label, value }) => (
                  <RadioBasic
                    name="unit_size"
                    key={value}
                    value={value}
                    label={label}
                    formData={props.formData}
                    defaultChecked={
                      props.formData.unit_size === value ||
                      props.formData[`unit_size_${value}`] === true
                    }
                    labelStyle={{
                      fontWeight: "400",
                      fontSize: "13px",
                    }}
                  />
                ))}
              </Column>
            </FormRow>
          </ShouldRenderField>

          <ShouldRenderField name="unit_size_group" vs={schema}>
            <div>
              <p style={{ marginBottom: 1 }}>What size unit do you want?</p>
              <FormRow>
                <Column width={12}>
                  {unitSizeMetadata.map(({ id, label }) => ({ id, label, name: `unit_size_${id}` }))
                    .map(({ id, label, name }) => (
                      <ShouldRenderField key={name} name={name} vs={schema}>
                        <Checkbox
                          label={label}
                          name={name}
                          formData={props.formData}
                          defaultChecked={
                            props.formData[name] ||
                          (props.formData.unit_size || "").split(",").includes(id)}
                        />
                      </ShouldRenderField>))}
                </Column>
              </FormRow>
            </div>
          </ShouldRenderField>
          <ShouldRenderField name="household_lives_works_in_alameda" vs={schema}>
            <RadioYesNo
              label="Do you work OR live in the City of Alameda, or have at least one adult member who lives or works in the City of Alameda?"
              name="household_lives_works_in_alameda"
              formData={props.formData}
            />
          </ShouldRenderField>
          <ShouldRenderField name="household_lives_works_in_san_carlos" vs={schema}>
            <RadioYesNo
              label="Does anyone in the household currently live or work in San Carlos?"
              name="household_lives_works_in_san_carlos"
              formData={props.formData}
            />
          </ShouldRenderField>
          <ShouldRenderField name="household_has_housing_authority_voucher" vs={schema}>
            <RadioYesNo
              label="Do you or anyone you plan to have living with you currently have a Rental Voucher from a Housing Authority (such as Section 8)?"
              name="household_has_housing_authority_voucher"
              formData={props.formData}
            />
          </ShouldRenderField>
          <ShouldRenderField name="household_receives_other_housing_assistance" vs={schema}>
            <RadioYesNo
              label="Do you or anyone you plan to have living with you currently receive any housing assistance program OTHER than Section 8?"
              name="household_receives_other_housing_assistance"
              formData={props.formData}
            />
          </ShouldRenderField>
          <ShouldRenderField name="household_receives_other_housing_assistance_subsidy_type" vs={schema}>
            <FormRow style={{ marginTop: -10 }}>
              <Column width={6}>
                <Input
                  label="Subsidy Type"
                  name="household_receives_other_housing_assistance_subsidy_type"
                  formData={props.formData}
                />
              </Column>
            </FormRow>
          </ShouldRenderField>

          <ShouldRenderField name="applicant_employee_of_nyc" vs={schema}>
            <RadioYesNo
              label="Are you an employee of the City of New York, the New York City Housing Development Corporation, the New York City Department of Housing Preservation and Development, the New York City Economic Development Corporation, the New York City Housing Authority, or the New York City Health and Hospitals Corporation?"
              name="applicant_employee_of_nyc"
              formData={props.formData}
            />
          </ShouldRenderField>
          <ShouldRenderField name="applicant_had_nyc_housing_involvement" vs={schema}>
            <RadioYesNo
              label="If yes, have you personally had any role or involvement in any process, decision, or approval regarding the housing development that is the subject of this application?"
              name="applicant_had_nyc_housing_involvement"
              formData={props.formData}
            />
          </ShouldRenderField>

          <ShouldRenderField name="household_all_full_time_students" vs={schema}>
            <RadioYesNo
              label="Are all household members full-time students?"
              name="household_all_full_time_students"
              formData={props.formData}
            />
          </ShouldRenderField>
          <ShouldRenderField name="household_has_pets" vs={schema}>
            <RadioYesNo
              label="Do you have any pets?"
              name="household_has_pets"
              formData={props.formData}
            />
          </ShouldRenderField>
          <ShouldRenderField name="household_owns_car" vs={schema}>
            <RadioYesNo
              label="Do you or anyone in your household own a car?"
              name="household_owns_car"
              formData={props.formData}
            />
          </ShouldRenderField>
          <ShouldRenderField name="household_disability" vs={schema}>
            <RadioYesNo
              label="Do you or your household have a disability need for a reasonable accommodation or modification?"
              name="household_disability"
              formData={props.formData}
            />
          </ShouldRenderField>

          <ShouldRenderField name="household_disability_answer" vs={schema}>
            <FormRow style={{ marginTop: -10 }}>
              <Column width={8}>
                <Input
                  label={getLabelFromSchema(schema, "household_disability_answer")}
                  name="household_disability_answer"
                  formData={props.formData}
                />
              </Column>
            </FormRow>
          </ShouldRenderField>

          <ShouldRenderField name="household_requires_impairment_mobility" vs={schema}>
            <RadioYesNo
              label="Do you or anyone who will be living with you require special unit design features for mobility impairment?"
              name="household_requires_impairment_mobility"
              formData={props.formData}
            />
          </ShouldRenderField>
          <ShouldRenderField name="household_requires_impairment_visual" vs={schema}>
            <RadioYesNo
              label="Do you or anyone who will be living with you require special unit design features for visual impairment?"
              name="household_requires_impairment_visual"
              formData={props.formData}
            />
          </ShouldRenderField>
          <ShouldRenderField name="household_requires_impairment_hearing" vs={schema}>
            <RadioYesNo
              label="Do you or anyone who will be living with you require special unit design features for hearing impairment?"
              name="household_requires_impairment_hearing"
              formData={props.formData}
            />
          </ShouldRenderField>
          <ShouldRenderField name="household_served_in_armed_forces" vs={schema}>
            <RadioYesNo
              label="Has anyone in the household served in the United States Armed Forces?"
              name="household_served_in_armed_forces"
              formData={props.formData}
            />
          </ShouldRenderField>

          {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13].map((i) => {
            const fieldName = `custom_pref_${i + 1}`;
            const answerFieldName = `custom_pref_${i + 1}_answer`;
            return (
              <div key={i} >
                <ShouldRenderField name={fieldName} vs={schema}>
                  <RadioYesNo
                    label={getLabelFromSchema(schema, fieldName)}
                    name={fieldName}
                    formData={formData}
                  />
                </ShouldRenderField>

                <ShouldRenderField name={answerFieldName} vs={schema}>
                  <FormRow style={{ marginTop: -10 }}>
                    <Column width={8}>
                      <Input
                        label={getLabelFromSchema(schema, answerFieldName)}
                        name={answerFieldName}
                        formData={formData}
                      />
                    </Column>
                  </FormRow>
                </ShouldRenderField>
              </div>
            );
          })}
        </div>

        <ShouldRenderField name="how_did_applicant_hear_about_property" vs={schema}>
          <FormRow>
            <Select
              label="How / where did you find out about this property?"
              name="how_did_applicant_hear_about_property"
              width={6}
              formData={props.formData}
              options={[
                "Newspaper",
                "Social Media",
                "Local Organization or Church",
                "Word of Mouth",
                "Affordable Housing Hotline",
                "Posted Sign",
                "Haven Connect",
                "Other",
              ]}
            />
          </FormRow>
        </ShouldRenderField>

        <ShouldRenderField name="extra_info" vs={schema}>
          <FormRow>
            <Column width={6}>
              <Input
                label="Anything else you’d like us to know about yourself"
                name="extra_info"
                formData={props.formData}
              />
            </Column>
          </FormRow>
        </ShouldRenderField>
      </div>
    </>
  );
};
export default InterestForm;
